<template>
  <ui-button
    class="recipe-love"
    icon="love"
    size="s"
    iconPosition="top"
    :class="{ active: isLike }"
    @click="like()"
    text
    :round="this.round"
  >
    <Fragment class="recipe-love__info" v-if="showCount">
      {{ count }} {{ label }}
    </Fragment>
  </ui-button>
</template>
<script>
import UiButton from "../ui/UiButton.vue";
import UserStore from "@/store/userStore";
import fetchApi from "@/mixins/fetchApi";
import { Fragment } from "vue-fragment";

export default {
  components: { UiButton, Fragment },
  props: {
    recipe: { required: true },
    showCount: { default: false },
    showLabel: { default: false },
    round: { required: false, default: false }
  },
  computed: {
    label() {
      return this.count > 1 ? "Likes" : "Like";
    },
    isLike() {
      return (
        UserStore.state.likes && UserStore.state.likes.includes(this.recipe.id)
      );
    }
  },
  data() {
    return {
      count: this.recipe.likes
    };
  },
  methods: {
    like() {
      this.likeAction();
    },
    async likeAction() {
      const response = await fetchApi.post("user/like", {
        recipe: this.recipe.id,
        is_like: this.isLike
      });

      if (response.status !== 401) {
        if (this.isLike) {
          UserStore.commit("removeFromLikes", this.recipe.id);
          this.count--;
        } else {
          UserStore.commit("addToLikes", this.recipe.id);
          this.count++;
        }
      }
    }
  }
};
</script>
<style lang="scss">
.recipe-love {
  padding: 5px;
  border: 0;
  background: rgba($white, 0.5) !important;
  border-radius: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s;
  z-index: 3;
  cursor: pointer;
  &.active {
    background: rgba($white, 0.9) !important;
    svg {
      fill: $red;
      stroke: $red;
    }
  }
}
</style>
